export default "__VITE_ASSET__f1f5ba96__"